import React, { useEffect, useMemo } from 'react';
import { matchPath, useLocation, useSearchParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  END_USER_RECIPES_ADVANCED_SEARCH_ROUTE,
  END_USER_RECIPES_MULTI_MENUS_ROUTE,
  END_USER_RECIPES_BOARD_ROUTE,
} from '../../services/routes';
import RecipesAdvancedSearchView from './recipes_advanced_search_view';
import RecipesEndUserAppHomePage from './recipes_end_user_app_home_page';
import RecipesEndUserFlattenedBoardView from './recipes_end_user_flattened_board_view';
import {
  useGetCurrentSpaceMembershipQuery,
  useGetOwnedRecipesBoardsQuery,
} from '../../app/smorgAppSyncGraphQLApiCustomHooks';
import { useCreateSmorgBoardMutation } from '../../app/smorgAppSyncGraphQLApi';
import { createEndUserFavouritesRecipesBoard } from '../../operations/recipes_operations';

const RecipesEndUserAppView = ({ mealDetailVisible }) => {
  const location = useLocation();

  const [searchParams] = useSearchParams();

  const parentIDs = searchParams.getAll('parentIDs');
  const menuIDs = searchParams.getAll('menuIDs');

  const memoizedParentIDs = useMemo(
    () => parentIDs,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(parentIDs)],
  );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memoizedMenuIDs = useMemo(() => menuIDs, [JSON.stringify(menuIDs)]);

  const menusWithParents = useMemo(
    () =>
      (memoizedParentIDs || []).map((parentID, i) => ({
        parentID,
        menuID: memoizedMenuIDs[i],
      })),
    [memoizedMenuIDs, memoizedParentIDs],
  );

  const { data: ownedRecipesBoards, isLoading: isOwnedRecipesLoading } = useGetOwnedRecipesBoardsQuery();

  const { data: currentSpaceMembership } = useGetCurrentSpaceMembershipQuery();

  const [createSmorgBoard] = useCreateSmorgBoardMutation();

  useEffect(() => {
    if (
      !isOwnedRecipesLoading &&
      !!currentSpaceMembership &&
      !!ownedRecipesBoards &&
      ownedRecipesBoards.length === 0
    ) {
      createEndUserFavouritesRecipesBoard(
        currentSpaceMembership.id,
        createSmorgBoard,
      );
    }
  }, [
    createSmorgBoard,
    currentSpaceMembership,
    isOwnedRecipesLoading,
    ownedRecipesBoards,
  ]);

  if (matchPath(END_USER_RECIPES_ADVANCED_SEARCH_ROUTE, location.pathname)) {
    return <RecipesAdvancedSearchView />;
  }

  const matchMultiMenusRoute = matchPath(
    END_USER_RECIPES_MULTI_MENUS_ROUTE,
    location.pathname,
  );

  if (matchMultiMenusRoute) {
    console.log({ parentIDs, menuIDs });
    return (
      <RecipesEndUserFlattenedBoardView menusWithParents={menusWithParents} />
    );
  }

  const matchRecipesBoardRoute = matchPath(
    END_USER_RECIPES_BOARD_ROUTE,
    location.pathname,
  );
  if (matchRecipesBoardRoute) {
    return (
      <RecipesEndUserFlattenedBoardView
        recipesBoardId={matchRecipesBoardRoute.params.recipesBoardId}
      />
    );
  }

  return <RecipesEndUserAppHomePage mealDetailVisible={mealDetailVisible} />;
};

RecipesEndUserAppView.propTypes = {
  mealDetailVisible: PropTypes.bool.isRequired,
};

export default RecipesEndUserAppView;
